export default __webpack_public_path__ + "static/media/Sony.047e31c4.svg";